import classNames from 'classnames';

import { RaiseHandIcon } from '../../icons/raise-hand';
import Hand from '../../icons/hand';

interface RaisedHandCornerIndicatorProps {
  className?: string;
}

export function RaisedHandCornerIndicator({ className }: RaisedHandCornerIndicatorProps) {
  return (
    <div
      className={classNames(
        'pointer-events-none absolute top-2 left-2 z-[20] flex h-9 w-9 items-center justify-center',
        className,
      )}
      title="Поднята рука"
      aria-hidden
    >
      <Hand width={36} height={36} className="drop-shadow-md" />
    </div>
  );
}
